import React, { useEffect, useState, useCallback } from 'react';
import { usePrefs, useLabels, useRequestData, useFlags } from 'wsm-common-data';
import { LocationModal } from 'wsm-location-modal';
import { useDispatch, useSelector } from 'react-redux';
import { API } from '../api/services';
import { getDistance } from '../utils/utility';
import { useLocationState } from '../features/location';
import { setDistance } from '../features/distance';

const Distance = () => {
	const dispatch = useDispatch();
	const distance = useSelector((state) => state.distance.distance);

	const prefs = usePrefs();
	const labels = useLabels();
	const flags = useFlags();
	const { locale } = useRequestData();
	const { vehicleLat, vehicleLong } = useLocationState();

	const showDistance = prefs.showDistanceFromShopper === 'true';
	const showDelivery = prefs.deliveryEnabled === 'true';

	const [userZip, setUserZip] = useState(null);

	const { deviceType } = useRequestData();
	const isMobile = deviceType === 'MOBILE';
	const [showLocationModal, setShowLocationModal] = useState(false);

	const flagNewDesign = flags['ws-vehicle-location-new-design'] || false;

	const fetchDistance = useCallback(
		async (postalCode, userLatitude, userLongitude) => {
			let result;
			if (postalCode) {
				result = await API.getDistanceFromLS(
					postalCode,
					vehicleLat,
					vehicleLong,
					locale
				);
				if (result?.distance) {
					dispatch(setDistance(result.distance));
					setUserZip(postalCode);
					return;
				}
			}
			if (userLatitude && userLongitude) {
				result = Math.round(
					getDistance(
						userLatitude,
						userLongitude,
						vehicleLat,
						vehicleLong,
						locale
					)
				);
				dispatch(setDistance(result));
				setUserZip(postalCode);
				return;
			}

			// Fallback if no distance is found
			dispatch(setDistance(null));
			setUserZip(null);
		},
		[vehicleLat, vehicleLong, locale, dispatch]
	);

	useEffect(() => {
		if (!distance && (showDistance || showDelivery)) {
			const sessionStorageLocation = JSON.parse(
				window?.sessionStorage?.getItem('session.location')
			);
			const userPostalCode =
				window?.localStorage?.getItem('userLocation') ||
				sessionStorageLocation?.userPostalCode;
			const { userLatitude, userLongitude } =
				sessionStorageLocation || {};

			fetchDistance(userPostalCode, userLatitude, userLongitude);
		}
	}, [distance, showDistance, showDelivery, fetchDistance]);

	const getLabeledValue = (label, userPostalCode) => {
		return labels
			.get(label)
			.replace(/\{\{distance\}\}/, distance)
			.replace(/\{\{location\}\}/, userPostalCode)
			.trim();
	};

	const onCloseLocationModal = () => {
		setShowLocationModal(false);
	};

	const onChangeUserPostalCode = (postalCode) => {
		const sessionStorageLocation = JSON.parse(
			window?.sessionStorage?.getItem('session.location')
		);
		const { userLatitude, userLongitude } = sessionStorageLocation || {};
		fetchDistance(postalCode, userLatitude, userLongitude);
	};

	if (showDistance && distance) {
		return (
			<>
				{flagNewDesign ? (
					<>
						<span className="ddc-font-size-xsmall mr-3 pr-2 text-muted d-flex align-items-center">
							{getLabeledValue('DISTANCE_FROM_LOCATION', '')}
							<button
								type="button"
								className="btn-unstyled btn-link text-muted mr-0 pl-1 ml-1 text-decoration-underline"
								onClick={() => setShowLocationModal(true)}
							>
								{userZip}
							</button>
						</span>
						<LocationModal
							userPostalCode={userZip}
							isOpen={showLocationModal}
							onClose={onCloseLocationModal}
							isMobile={isMobile}
							title={labels.get('YOUR_LOCATION')}
							onChangeUserPostalCode={onChangeUserPostalCode}
						/>
					</>
				) : (
					<div>
						<span className="ddc-font-size-xsmall">
							{getLabeledValue('DISTANCE_FROM_LOCATION', userZip)}
						</span>
					</div>
				)}
			</>
		);
	} else {
		return null;
	}
};

export default Distance;
